import _ from 'lodash';
//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import {
	getNewBeneficiary,
	getMessage,
	getBeneficiaryDetails,
	getBeneficiaryBankDetails,
	getPaymentOptions,
	setMessage,
} from 'state/reducers/beneficiary.reducers';
import { getCountries, getCurrencies } from 'state/reducers/global.reducers';
//components
import { FormsStack } from 'theme/elements/Forms';
import { InfoCard, LightGreenCard } from 'theme/elements/Cards';
import { FormHeader1 } from 'theme/elements/Headers';
import { Paragraph3 } from 'theme/elements/Paragraphs';
//sections
//mui
import { Grid, Stack, useTheme } from '@mui/material';
//constants
import { Beneficiary, BeneficiaryStatus, paymentsMethodsDisplayList } from 'constants/beneficiary.constants';
import { Fragment, useMemo } from 'react';
import { userMessage } from 'constants/ui.constants';
import WarningDialog from 'components/WarningDialog';

export default function Details(props: {}) {
	const beneficiary: Beneficiary = useAppSelector(getNewBeneficiary);
	const userMessage: userMessage = useAppSelector(getMessage);
	const beneficiaryDetails = useAppSelector(getBeneficiaryDetails);
	const beneficiaryBankDetails = useAppSelector(getBeneficiaryBankDetails);
	const Countries = _.keyBy(useAppSelector(getCountries), 'id');
	const Currencies = _.keyBy(useAppSelector(getCurrencies), 'id');
	const paymentOptions = useAppSelector(getPaymentOptions);
	const intersect = (type) => {
		let obj: Partial<Beneficiary> = {};
		try {
			let gp = _.groupBy(paymentOptions, 'type');
			if (_.get(gp, type)) {
				_.values(gp[type]).forEach((pay) => {
					if (pay.optional) {
						pay.fields.forEach((field) => {
							switch (field) {
								case 'acct_number':
									obj.acctNumber = beneficiary.acctNumber;
									break;
								case 'bic_swift':
									obj.bicSwift = beneficiary.bicSwift;
									break;
								default:
									obj[field] = beneficiary[field];
							}
						});
					}
				});
			}
		} catch (e) {}
		return obj;
	};
	const prefixFields = 'forms.beneficiary.field.';
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();

	function formatValue(value: string, key: string) {
		switch (key) {
			case 'countryId':
			case 'bankAccountCountryId':
				return _.get(Countries[value], 'name') || '';
			case 'currencyId':
				return _.get(Currencies[value], 'name') || '';
				break;
				break;
			default:
				return value;
		}
	}

	const openDialog = useMemo(() => {
		return userMessage.exist;
	}, [userMessage]);

	return (
		<Fragment>
			<WarningDialog
				open={openDialog}
				title={t(userMessage.text || '')}
				subTitle={userMessage.subText}
				handleCancel={() => {
					dispatch(setMessage({ exist: false }));
				}}
			/>
			<FormsStack>
				<InfoCard>
					<FormHeader1 title={t('card.beneficiary.title.beneficiary_details')} />
					<Stack spacing={2}>
						{_.keys(beneficiaryDetails).map((field) => {
							return (
								<Paragraph3
									key={field}
									color={theme.palette.root.basicDeepBlue}
									title={t(prefixFields + field)}
									text={formatValue(_.get(beneficiaryDetails, field), field)}
								/>
							);
						})}
					</Stack>
				</InfoCard>
				<>
					{!_.isEqual(beneficiary.status, BeneficiaryStatus.PendingBankAccountDetails) && (
						<InfoCard>
							<FormHeader1 title={t('card.beneficiary.title.beneficiary_bank_details')} />
							<Stack spacing={2}>
								{_.keys(beneficiaryBankDetails).map((field) => {
									return (
										<Paragraph3
											key={field}
											color={theme.palette.root.basicDeepBlue}
											title={t(prefixFields + field)}
											text={formatValue(_.get(beneficiaryBankDetails, field), field)}
										/>
									);
								})}
								<LightGreenCard>
									<Grid flexDirection="column" container display="flex">
										<Stack spacing={2}>
											{paymentsMethodsDisplayList.map((field) => {
												return !_.isNil(_.get(beneficiary, field)) ? (
													<Paragraph3
														color={theme.palette.root.basicDeepBlue}
														key={field}
														title={t(prefixFields + field)}
														text={_.get(beneficiary, field)}
													/>
												) : (
													''
												);
											})}
										</Stack>
									</Grid>
								</LightGreenCard>
							</Stack>
						</InfoCard>
					)}
				</>
			</FormsStack>
		</Fragment>
	);
}
